import { db } from "../firebase";
import { doc, setDoc, increment, serverTimestamp } from "firebase/firestore";

/**
 * Records a page visit in Firestore with country detection.
 * Aggregates data daily to optimize for reporting and minimize costs.
 */
export async function recordVisit(path, productId = null) {
    // Don't track admin pages or tracking pages that might contain sensitive IDs
    if (path.startsWith("/admin") || path.startsWith("/activate-admin")) return;

    try {
        // 1. Get Country (cached in session storage to avoid redundant API calls)
        let country = sessionStorage.getItem("visitor_country");
        if (!country) {
            try {
                // Using ipapi.co (free tier: 1000 requests/day)
                const res = await fetch("https://ipapi.co/json/");
                const data = await res.json();
                country = data.country_name || "Unknown";
                sessionStorage.setItem("visitor_country", country);
            } catch (err) {
                console.warn("Could not detect country:", err);
                country = "Unknown";
            }
        }

        // 2. Get Day ID (YYYY-MM-DD)
        const date = new Date();
        const dayId = date.toISOString().split("T")[0];
        const docRef = doc(db, "analytics", dayId);

        // 3. Prepare dynamic keys (Firestore keys cannot contain dots or slashes easily)
        // We replace '/' with '$' and '.' with '_'
        const safePath = path === "/" ? "home" : path.replace(/\//g, '$').replace(/\./g, '_');
        const safeCountry = country.replace(/\./g, '_');

        const updates = {
            totalVisits: increment(1),
            pages: {
                [safePath]: increment(1)
            },
            countries: {
                [safeCountry]: increment(1)
            },
            lastUpdated: serverTimestamp()
        };

        if (productId) {
            // If it's a product or bundle page, track it specifically
            updates.products = {
                [productId]: increment(1)
            };
        }

        // 4. Update the daily document
        await setDoc(docRef, updates, { merge: true });

    } catch (e) {
        // Silently fail analytics to not break user experience
        console.debug("Analytics recording skipped:", e.message);
    }
}
